import React, { useEffect, useRef } from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
}
export function Tabs({
  tabs,
  activeTab,
  onTabChange
}: TabsProps) {
  const tabsRef = useRef<HTMLDivElement>(null);
  const activeTabRef = useRef<HTMLButtonElement>(null);
  // Scroll active tab into view when it changes
  useEffect(() => {
    if (activeTabRef.current && tabsRef.current) {
      const tab = activeTabRef.current;
      const container = tabsRef.current;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerScroll = container.scrollLeft;
      const containerWidth = container.offsetWidth;
      if (tabLeft < containerScroll || tabLeft + tabWidth > containerScroll + containerWidth) {
        tab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [activeTab]);
  return <div className="w-full border-b border-gray-200 bg-white" data-id="element-1243">
      <div ref={tabsRef} className="flex overflow-x-auto no-scrollbar" role="tablist" data-id="element-1244">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} ref={isActive ? activeTabRef : null} onClick={() => onTabChange(tab.id)} role="tab" aria-selected={isActive} className={`
                relative whitespace-nowrap px-6 py-3 text-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-inset
                ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}
              `} data-id="element-1245">
              {tab.label}
              {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" data-id="element-1246" />}
            </button>;
      })}
      </div>
    </div>;
}